import React from 'react';

const Tooltip = ({ nombre, x, y }) => {
  if (!nombre) return null; // No muestra nada si no hay municipio activo

  const estilo = {
    position: 'fixed',
    left: `${x + 15}px`, // Desfase para que no tape el cursor
    top: `${y + 15}px`,
    backgroundColor: '#1a73e8',
    color: '#0b0f16',
    padding: '6px 12px',
    borderRadius: '4px',
    fontSize: 'small',
    fontWeight: 'bolder',
    pointerEvents: 'none', // Evita parpadeos al chocar con el cursor
    zIndex: 1000,
    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
  };

  return <div style={estilo}>{nombre}</div>;
};

export default Tooltip;
